<template>
    <section class="promo-gallery section">
        <h2 class="sub-title">{{ info.title }}</h2>
        <p  class="promo-gallery__desc">{{ info.desc }}</p>
        <section class="promo-gallery__inner">
            <VueSlickCarousel v-bind="settings" class="carousel-items__slider slider slider-carousel">
                <div class="carousel-items__slider-item" v-for="sliderItem of sliderItems">
                    <img class="carousel-items__slider-item-img" :src="sliderItem.link">
                </div>
                <template #prevArrow="arrowOption">
                    <button type="button" class="slick-arrow _prev">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider"/>
                        </svg>
                    </button>
                </template>
                <template #nextArrow="arrowOption">
                    <button type="button" class="slick-arrow _next">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider"/>
                        </svg>
                    </button>
                </template>
            </VueSlickCarousel>
        </section>
    </section>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'carouselPromoItems',
    props: ['info'],
    components: {VueSlickCarousel},
    data() {
        return {
            settings: {
                arrows: false,
                dots: true,
                infinite: true,
                slidesToScroll: 3,
                slidesToShow: 4,
                autoplay: true,
                autoplaySpeed: 10000,
                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 994,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            },
            sliderItems: [
                {
                    link: '/assets/img/promo/1.jpg',
                },
                {
                    link: '/assets/img/promo/2.jpg',
                },
                {
                    link: '/assets/img/promo/3.jpg',
                },
                {
                    link: '/assets/img/promo/4.jpg',
                },
                {
                    link: '/assets/img/promo/5.jpg',
                },
                {
                    link: '/assets/img/promo/6.jpg',
                },
                {
                    link: '/assets/img/promo/7.jpg',
                },
                {
                    link: '/assets/img/promo/8.jpg',
                },
                {
                    link: '/assets/img/promo/9.jpg',
                },
                {
                    link: '/assets/img/promo/10.jpg',
                },
                {
                    link: '/assets/img/promo/11.jpg',
                },
                {
                    link: '/assets/img/promo/12.jpg',
                },
                {
                    link: '/assets/img/promo/13.jpg',
                },
                {
                    link: '/assets/img/promo/14.jpg',
                },
                {
                    link: '/assets/img/promo/15.jpg',
                },
            ]
        }
    },
}
</script>


